export * from './user-profile-new.component';
